<template>
  <div class="about">
    <h1>Tentang Kami</h1>
    <h2>Visi</h2>
    <h2>Misi</h2>
    <p>Berisi profil akademi, visi - misi, dan struktur organisasi</p>
  </div>
</template>
